class AuditoriaEstoqueController extends AbstractController
  @$inject = ['$injector', '$scope', '$filter', '$uibModal', 'gql', 'ngTableParams', 'pathService', 'api', 'authService', 'timeService', 'tipoDestinacaoService', 'auditoriaEstoqueService', 'UsuariosService', 'EfSocket']

  constructor: ($injector, @scope, @$filter, @modal, @gql, ngTableParams, @pathService, @api, @authService, @timeService, @tipoDestinacaoService, @auditoriaEstoqueService, @UsuariosService, @EfSocket) ->
    super($injector)

    @apply = (func) -> @scope.$apply func

    @listOfMonth = []
    
    @url = @pathService.getViewUrl() + 'eficiencia-fiscal/view/dashboard/'
    @modalArquivo = @openPopup(@url + 'auditoria-estoque/modal.html', 'escrituracaoEnviarArquivoController as ctrl', 'lg', 'static')
    @modalDetalhes = @openPopup(@url + 'auditoria-estoque/modal-detalhes.html', 'escrituracaoDetalhesController as ctrl', 'lg', 'static')
    @modalEscrituracao = @openPopup(@url + 'auditoria-estoque/modal-escrituracoes.html', 'escrituracoesController as ctrl', 'lg', 'static')
    @modalLinks = @openPopup(@url + 'auditoria-estoque/modal-links.html', 'auditoriaLinkController as ctrl', 'lg', 'static')

    @contratoId = @scope.tabData.contratoId

    @msgCsosn101 = """
    NT 2015/03, quando o destinatário for contribuinte do ICMS, utilizar os CSOSN de ICMS previstos na regra de validação da Sefaz, que são 101, 103, 300, 400 e 500.
    NT 2015/03, quando o destinatário for não contribuinte do ICMS (indIEDest = 9), utilizar os CSOSN de ICMS previstos na regra de validação da Sefaz, que são 102, 103, 300, 400 e 500.
    """

    @filtro = {divergente: true, inconsistencias: 'com', revisado: null}

    @scope.$watch('ctrl.filtro', (newVal, oldVal) =>
      @filtro.divergencias = [] if newVal.divergente != oldVal.divergente and !newVal.divergente
      @filtro.divergente = true if newVal.divergencias?.length != oldVal.divergencias?.length and newVal.divergencias?.length > 0

      if @empresa 
        cbk.search(=> @loadData())()
    , true)
    
    @usuario = {}
    @authService.getCurrentUser((user) => @usuario = user)

    @onInit()
    
  onInit: () ->
    meses = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro'
    ]

    @timeService
      .getList()
      .then(({data: {data}})=>
        atual = new Date(data.dataAtual)
        dataInicial = new Date(atual.getFullYear(), atual.getMonth()+1, 1)
        @listOfMonth = [1..24].map((i) ->
          data = new Date(dataInicial.getFullYear(), dataInicial.getMonth() - i, 1)
          {id: data, text: (meses[data.getMonth()] + ' de ' + data.getFullYear())}
        )
      )

  onSelectEmpresa: () ->
    return if not @empresa.icms
    return if not @empresa.pisCofins

    @cstCsosn = if @empresa.icms?.simplesNacional then 'CSOSN' else 'CST'

    @channel = "auditoria_continua:#{@empresa.id}"    
    @pagination = {}
    @pendentes = 0
    @ultimaQuantidadePendente = null

    @tiposDivergencia = [
      {id: 'aliquota_icms',   title: 'Alíquota do ICMS PDV'}
      {id: 'cst_icms',   title: 'CST do ICMS'}
      {id: 'aliquota_pis',    title: 'Alíquota do PIS'}
      {id: 'cst_pis',    title: 'CST do PIS'}
      {id: 'aliquota_cofins', title: 'Alíquota do COFINS'}
      {id: 'cst_cofins', title: 'CST do COFINS'}
      {id: 'ncm',    title: 'NCM'}
    ]

    @tiposDivergencia = @tiposDivergencia.reject((d) => d.id in ['aliquota_pis', 'aliquota_cofins'] and @empresa.pisCofins?.simplesNacional)

    @socket().on(@channel, "quantidade_pendente", (data) =>
      if @pendentes > 0 and data.pendentes == 0
        Alert.success("Auditoria contínua finalizada.")

      if @ultimaQuantidadePendente? and @ultimaQuantidadePendente > data.pendentes
        @apply => @itensNovos = @ultimaQuantidadePendente - data.pendentes

      @apply => @pendentes = data.pendentes
    )

    @promise = @api
      .get('/icms/tipo-destinacao', estado_sigla: @empresa.estado)
      .then(({data}) =>
        @listOfTipoDestinacao = data.items
      )
      .then(=> @loadData())

  configurarIcms: () =>  
    @modal.open({
      component: 'configuracaoIcmsModal',
      size: 'lg',
      keyboard: 'static',
      resolve: {
          empresaId: () => @contratoId,
          filialId: () => @empresa.id
      }
    }).result.then((result) => 
      if result
        @empresa.icms = result
        @onSelectEmpresa()
    )
  
  configurarPisCofins: () => 
    @modal.open({
      component: 'configuracaoPisCofinsModal',
      size: 'lg',
      keyboard: 'static',
      resolve: {
          empresaId: () => @contratoId,
          filialId: () => @empresa.id
      }
    }).result.then((result) => 
      if result
        @empresa.pisCofins = result
        @onSelectEmpresa()
    )

  hasAcesso: (empresa) ->
    empresa.ferramentasDisponiveis.includes("auditoria-continua-itens")

  buildFiltro: (page = null) ->
    params = {filial_id: @empresa.id, page: page}
    params.auditado = @filtro.inconsistencias != "nao_auditados"
    params.divergencias = 
      if @filtro.inconsistencias == "com"
        if @filtro.divergencias?.length > 0
          @filtro.divergencias
        else
          @tiposDivergencia.map((d) => d.id)
    params.divergente = false if @filtro.inconsistencias == 'sem'
    params.revisado = @filtro.revisado if @filtro.revisado in [true, false]
    params.busca = @filtro.busca if @filtro.busca
    params.movimentacao = @filtro.movimentacao if @filtro.movimentacao?
    params.ultima_movimentacao = @filtro.ultima_movimentacao if @filtro.ultima_movimentacao?
    params.tipo_item = @filtro.tipo_item.codigo if @filtro.tipo_item?

    if @filtro.inconsistencias == 'todas'
      delete params.divergente
      delete params.auditado

    return params

  loadData: (page = 1) ->
    params = @buildFiltro(page)
    @promise = @api
      .get('/auditoria-tributaria/estoque', params)
      .then(({data}) =>
        @pagination = {
          page: data.page
          total: data.total_pages
          perPage: 1
        }

        @listOfDivergencias = data.items
        @count = data.count
        @ultimaQuantidadePendente = @pendentes
        @itensNovos = 0
      )
      .catch(=>
        Alert.warning('Não foi possível carregar a lista de divergências. Por favor, entre em contato com a equipe de suporte', 'Atenção', 10000)
      )

  alterarClassificacao: (divergencia) ->
    @modal.open({
      backdrop: 'static',
      keyboard: false,
      component: 'ajustarClassificacaoModal',
      resolve: {
        channel: () => @channel,
        estoque: () => divergencia.estoque
      }
    }).result.then((novaDivergencia) =>
      @listOfDivergencias = @listOfDivergencias.map((d) =>
        if d.estoque.id == novaDivergencia.estoque.id
          novaDivergencia
        else
          d
      )
    )

  revisar: (auditoria) ->
    @socket().push(@channel, "alternar_revisao", {id: auditoria.id})
      .then((data) => @apply -> auditoria.revisado = data.revisado)
      .catch(=> @Alert.warning('Não foi possível revisar o item.', 'Atenção', 10000))

  linkSac: (devergencia) ->
    url = "http://sac.eficienciafiscal.com.br/sac-servico-de-atendimento-ao-consumidor/"
    url+= "?sac-razao-social-empresa=#{@empresa.razaoSocial.replace('&', '%26')}"
    url+= "&your-name=#{@usuario.nome}"
    url+= "&your-email=#{@usuario.email}"
    url+= "&sac-cnpj-empresa=#{@empresa.cnpj}"
    url+= "&nfe=Auditoria+estoque%2C+c%C3%B3digo%3A+#{devergencia.estoque.codigo}"
    url+= "&sac-ncm-cod-barras=#{devergencia.estoque.ncm}"

  enviar: ->
    @modalArquivo({
      empresa: => @empresa
    }, (result) =>
      @loadData()
    )

  toUnderscore: (str) ->
    str.replace(/([A-Z])/g, ($1) ->  "_" + $1.toLowerCase())

  parseResultado: (parsed, resultado) ->
    return parsed unless resultado

    for k, v of resultado
      parsed[@toUnderscore(k)] = v

    return parsed

  detalhes: (auditoria) ->
    resultado = angular.copy(auditoria.resultado)
    resultado.retorno_icms = @parseResultado(resultado.retorno_icms, resultado.retorno_icms)
    resultado.retorno_icms.retorno_rbc = @parseResultado(resultado.retorno_icms.retorno_rbc, resultado.retorno_icms?.retorno_rbc)
    resultado.retorno_icms.tipo =
      switch resultado.retorno_icms.class
        when 'EficienciaFiscal\\Icms\\Model\\RetornoSubstituicaoTributaria' then "substituicao_tributaria"
        when 'EficienciaFiscal\\Icms\\Model\\RetornoIsencao' then "isencao"
        when 'EficienciaFiscal\\Icms\\Model\\RetornoReducaoBaseCalculo' then "reducao_base_calculo"
        when 'EficienciaFiscal\\Icms\\Model\\RetornoTributacaoNormal' then "tributacao_normal"

    @modalDetalhes({
      empresa: => @empresa,
      auditoria: => resultado
    })

  detalhesNcmAntigo: (auditoria) ->
    resultado = angular.copy(auditoria.resultado)

    @modalDetalhes({
      empresa: => @empresa,
      auditoria: => {retorno_ncm: resultado.retorno_ncm_antigo}
    })

  abrirEscrituracoes: ->
    @modalEscrituracao({
      empresa: => @empresa
    })

  compartilhar: () ->
    filtro = @buildFiltro()
    @modalLinks({
      empresa: => @empresa
      filtro: => filtro
    })

  gerarRelatorio: (format) ->
    params = @buildFiltro()
    params.format = format

    for key, val of params
      if val == undefined || val == null 
        delete params[key]

    cbk.download("/api/auditoria-tributaria/estoque?#{$.param(params)}")

  getTipoAlerta: (divergencia, tipo) ->
    if divergencia.estoque[tipo]?
      if tipo in ['cst_pis', 'cst_cofins'] and divergencia.auditoria[tipo]?
        [e_entrada, e_saida] = divergencia.estoque[tipo].split('/')
        [a_entrada, a_saida] = divergencia.auditoria[tipo].split('/')
        if (e_entrada == '--' or e_entrada == a_entrada) and (e_saida == '--' or e_saida == a_saida)
          'warning'
        else
          'danger'
      else
        'danger'
    else
      if tipo in ['ncm', 'ex_tipi', 'cest']
        'danger'
      else
        'warning'

  socket: () -> @EfSocket.socket(@UsuariosService.token)

angular.module("eficienciaFiscalModule").controller('auditoriaEstoqueController', AuditoriaEstoqueController)


class EscrituracaoEnviarArquivoController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'Upload', 'empresa']

  constructor: ($injector, @modalInstance, @Upload, empresa) ->
    super($injector)

    @submitTracker = @promiseTracker()
    @url = "/api/filiais/#{empresa.id}/escrituracao"

  getErrorMessage: (message) ->
    switch message
      when "cnpj_invalido" then "O CNPJ presente no arquivo não corresponde ao da empresa selecionada."
      when "periodo_invalido" then "O arquivo SPED compreende mais do que um mês. Certifique-se de que o arquivo tem seu início e fim no mesmo mês/ano."
      when "arquivos_incompativeis" then "Os cabeçalhos dos arquivos SPED enviados são incompatíveis. Certifique-se de que o período e o CNPJ dos arquivos são os mesmos."
      else "Erro desconhecido. Entre em contato com o suporte tècnico."

  enviar: (form) ->
    if form.$valid
      @submitTracker.addPromise(
        @Upload.upload(
          url: @url,
          headers: cbk.getHeaders()
          data: {efd_icms: @efd_icms, efd_pis_cofins: @efd_pis_cofins}
        )
        .then(({data: {mes, ano}}) =>
          @Alert.success("Arquivo de #{mes}/#{ano} enviado com sucesso.", 'Sucesso', 10000)
          @close()
        , null
        , (evt) => @progress = parseInt(100.0 * evt.loaded / evt.total)
        )
        .catch(({data: {error}}) => @Alert.warning("Ocorreu um erro ao enviar o arquivo: <br/> #{@getErrorMessage(error)}", 'Atenção', false))
      )

  close: ->
    @modalInstance.close(new Retorno(true))

angular.module("eficienciaFiscalModule").controller('escrituracaoEnviarArquivoController', EscrituracaoEnviarArquivoController)


class EscrituracaoDetalhesController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'auditoria', 'empresa']

  constructor: ($injector, @modalInstance, @auditoria, @empresa) ->
    super($injector)

angular.module("eficienciaFiscalModule").controller('escrituracaoDetalhesController', EscrituracaoDetalhesController)


class EscrituracaoNaoImportadosController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'itens']

  constructor: ($injector, @modalInstance, @itens) ->
    super($injector)

angular.module("eficienciaFiscalModule").controller('escrituracaoNaoImportadosController', EscrituracaoNaoImportadosController)

class EscrituracoesController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'pathService', 'api', 'empresa']

  constructor: ($injector, @modalInstance, pathService, api, empresa) ->
    super($injector)

    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/dashboard/'
    @modalNaoImportados = @openPopup(@url + 'auditoria-estoque/modal-nao-importados.html', 'escrituracaoNaoImportadosController as ctrl', 'md', 'static')

    @loadingTracker = @promiseTracker()

    @listOfMes = [
      {id: '01', nome: 'Janeiro'},
      {id: '02', nome: 'Fevereiro'},
      {id: '03', nome: 'Março'},
      {id: '04', nome: 'Abril'},
      {id: '05', nome: 'Maio'},
      {id: '06', nome: 'Junho'},
      {id: '07', nome: 'Julho'},
      {id: '08', nome: 'Agosto'},
      {id: '09', nome: 'Setembro'},
      {id: '10', nome: 'Outubro'},
      {id: '11', nome: 'Novembro'},
      {id: '12', nome: 'Dezembro'}
    ]

    @loadingTracker.addPromise(
      api.get("/filiais/#{empresa.id}/escrituracao")
        .then(({data: {escrituracoes}}) => @listOfEscrituracao = escrituracoes)
    )

  exibirNaoImportados: (itens) ->
    @modalNaoImportados({
      itens: => itens
    })

angular.module("eficienciaFiscalModule").controller('escrituracoesController', EscrituracoesController)

class AuditoriaLinkController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'pathService', 'promptService', 'api', 'empresa', 'filtro']

  constructor: ($injector, @modalInstance, @pathService, @promptService, @api, @empresa, @filtro) ->
    super($injector)

    @campos = []
    @descricao = ""

    @camposDados = [
      {id: "tipo_item", title: "Tipo"}
    ]

    @camposCadastroItem = [
      {id: 'estoque_aliquota_icms',   title: 'Alíquota do ICMS'}
      {id: 'estoque_aliquota_icms_pdv',   title: 'Alíquota do ICMS PDV'}
      {id: 'estoque_cst_icms',   title: 'CST do ICMS'}
      {id: 'estoque_aliquota_pis',    title: 'Alíquota do PIS'}
      {id: 'estoque_cst_pis',    title: 'CST do PIS'}
      {id: 'estoque_aliquota_cofins', title: 'Alíquota do COFINS'}
      {id: 'estoque_cst_cofins', title: 'CST do COFINS'}
      {id: 'estoque_cest',   title: 'CEST'}
    ]

    @camposSugestaoEf = [
      {id: 'auditoria_aliquota_icms',   title: 'Alíquota do ICMS'}
      {id: 'auditoria_aliquota_icms_pdv',   title: 'Alíquota do ICMS PDV'}
      {id: 'auditoria_cst_icms',   title: 'CST do ICMS'}
      {id: 'auditoria_aliquota_pis',    title: 'Alíquota do PIS'}
      {id: 'auditoria_cst_pis',    title: 'CST do PIS'}
      {id: 'auditoria_aliquota_cofins', title: 'Alíquota do COFINS'}
      {id: 'auditoria_cst_cofins', title: 'CST do COFINS'}
      {id: 'auditoria_cest',   title: 'CEST'}
    ]

    @listOfCampos = [
      {title: 'Dados do item', list: @camposDados},
      {title: 'Cadastro do item', list: @camposCadastroItem},
      {title: 'Sugestão EF', list: @camposSugestaoEf}
    ]

    @loadingTracker = @promiseTracker()
    @loadData()

  loadData: ->
    @loadingTracker.addPromise(
      @api.get('/auditoria-tributaria/estoque/link', filial_id: @empresa.id)
        .then(({data}) => @listOfLink = data.links)
    )

  enviarEmail: (link) ->
    @url = @pathService.getViewUrl() + 'eficiencia-fiscal/view/dashboard/'
    @promptService.open(@url + 'auditoria-estoque/modal-envio.html', (email) =>
      @api.post("/auditoria-tributaria/estoque/link/#{link.id}/enviar", email: email)
        .then(-> Alert.success("Email contendo o link enviado para #{email}.", 'Sucesso'))
    )

  criar: ->
    @loadingTracker.addPromise(
      @api.post('/auditoria-tributaria/estoque/link', link: {filtro: @filtro, campos: @campos, descricao: @descricao}, filial_id: @empresa.id)
        .then(=>
          @campos = []
          @descricao = ""
          @verLinks = true
          @cadastrar = false
          @loadData()
        )
    )

  delete: (link) ->
    Confirm.warning('Atenção', "Deseja realmente excluir o link de compartilhamento número ##{link.id}?", {
      'Sim': =>
        @loadingTracker.addPromise(
          @api.delete("/auditoria-tributaria/estoque/link/#{link.id}", filial_id: @empresa.id)
            .then(=> @loadData())
        )
      'Não': => null
    })

angular.module("eficienciaFiscalModule").controller('auditoriaLinkController', AuditoriaLinkController)
